import React, { useContext } from 'react';
import { JobPostingContext } from '../../../../contexts/JobPostingContext';
import { JOB_POSTING_STATUS } from '../../../../utils/constants';

import {
  DeleteJobPosting,
  ReopenJobPosting,
  CancelJobPosting,
  EditorModeButtons,
  EditJobPosting,
  MarkCompleteJobPosting,
  PublishJobPosting,
  DuplicateJobPosting
} from './Buttons';

export const ActionsButtons = ({ status }) => {
  const { DRAFT, ACTIVE, COMPLETED, CANCELLED } = JOB_POSTING_STATUS;

  const { editorModeActive } = useContext(JobPostingContext);

  if (editorModeActive) {
    return (
      <div className="ptp-job-posting__border-spacer ptp-job-posting__side-bar-padding-wrapper">
        {renderButton([DRAFT, ACTIVE], status) && <EditorModeButtons />}
      </div>
    );
  }

  return (
    <div className="ptp-job-posting__border-spacer ptp-job-posting__side-bar-padding-wrapper">
      {renderButton([DRAFT, ACTIVE], status) && <EditJobPosting />}
      {renderButton([DRAFT, ACTIVE, COMPLETED, CANCELLED], status) && <DuplicateJobPosting />}
      {renderButton([DRAFT], status) && <PublishJobPosting active={!editorModeActive} />}
      {renderButton([ACTIVE], status) && <MarkCompleteJobPosting />}
      {renderButton([CANCELLED, COMPLETED], status) && <ReopenJobPosting />}
      {renderButton([ACTIVE], status) && <CancelJobPosting />}
      {renderButton([DRAFT, COMPLETED, CANCELLED], status) && <DeleteJobPosting />}
    </div>
  );

  function renderButton(approvedStatuses, currentStatus) {
    return approvedStatuses.includes(currentStatus);
  }
};
